import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconRetry: React.FC<IconProps> = ({ width = 13, height = 13, color = '#888888' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 13 13"
            fill="none"
        >
            <g clip-path="url(#clip0_13128_7159)">
                <path
                    d="M3.85811 7.27572C4.03846 7.06884 3.89155 6.74582 3.61709 6.74582H2.79535C2.79 6.66452 2.78701 6.58258 2.78701 6.49995C2.78701 4.45257 4.45265 2.78693 6.5 2.78693C7.48389 2.78693 8.37947 3.17172 9.04455 3.79855L10.2033 2.44299C9.18895 1.51509 7.88359 1.00684 6.5 1.00684C5.03274 1.00684 3.65331 1.57823 2.6158 2.61572C1.57831 3.65324 1.00691 5.03267 1.00691 6.49993C1.00691 6.5822 1.00896 6.66414 1.01254 6.7458H0.32039C0.0459298 6.7458 -0.101004 7.06881 0.0793653 7.27569L1.64076 9.0667L1.96873 9.44289L3.14622 8.09222L3.85811 7.27572Z"
                    fill={color}
                />
                <path
                    d="M12.9224 6.23067L11.7578 4.89482L11.033 4.06348L9.99824 5.25044L9.14368 6.23067C8.96334 6.43755 9.11024 6.76057 9.38471 6.76057H10.2055C10.0712 8.68674 8.46145 10.2128 6.50177 10.2128C5.64632 10.2128 4.85762 9.9219 4.22911 9.43396L3.07031 10.7896C4.04108 11.5692 5.23878 11.9929 6.50179 11.9929C7.96905 11.9929 9.34848 11.4216 10.386 10.3841C11.3618 9.40824 11.9251 8.12993 11.9887 6.76059H12.6814C12.9558 6.76057 13.1027 6.43755 12.9224 6.23067Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_13128_7159">
                    <rect width="13" height="13" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconRetry;
